document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.querySelectorAll('[data-needs-section]').forEach((section) => {
  const triggers = Array.from(section.querySelectorAll('[data-need-trigger]'));
  const panels = Array.from(section.querySelectorAll('[data-need-panel]'));

  const closeAll = () => {
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    panels.forEach((panel) => { panel.hidden = true; });
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const panel = section.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeAll();
      if (!panel || wasOpen) return;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });

  section.querySelectorAll('[data-need-close]').forEach((button) => {
    button.addEventListener('click', closeAll);
  });
});

const formatMoney = (cents) => {
  const currency = window.Shopify?.currency?.active || 'EUR';
  return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
    style: 'currency',
    currency,
  }).format(Number(cents) / 100);
};

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const variantsNode = root.querySelector('[data-product-variants]');
  const form = root.querySelector('.product-form');
  if (!variantsNode || !form) return;

  let variants = [];
  try { variants = JSON.parse(variantsNode.textContent || '[]'); } catch (_) { return; }

  const updateVariant = () => {
    const selected = Array.from(form.querySelectorAll('fieldset')).map((fieldset) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    });
    const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
    const idInput = form.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const button = root.querySelector('[data-add-button]');
    const text = root.querySelector('[data-add-text]');

    if (!variant) {
      if (button) button.disabled = true;
      if (text) text.textContent = 'Combinaison indisponible';
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (price) price.textContent = formatMoney(variant.price);
    if (button) button.disabled = !variant.available;
    if (text) text.textContent = variant.available ? 'Ajouter au panier' : 'Produit indisponible';
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  form.addEventListener('change', updateVariant);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;

    const button = root.querySelector('[data-add-button]');
    const text = root.querySelector('[data-add-text]');
    const status = root.querySelector('[data-product-form-status]');
    const defaultText = text?.textContent || 'Ajouter au panier';

    form.dataset.submitting = 'true';
    if (button) button.disabled = true;
    if (text) text.textContent = 'Ajout en cours…';
    if (status) {
      status.hidden = true;
      status.textContent = '';
      status.classList.remove('is-error', 'is-success');
    }

    try {
      const response = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || 'Ajout impossible pour le moment.');

      const cartResponse = await fetch(root.dataset.cartJsonUrl || '/cart.js', {
        headers: { Accept: 'application/json' },
      });
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((counter) => {
          counter.textContent = String(cart.item_count || 0);
          counter.hidden = !cart.item_count;
        });
        document.querySelectorAll('.cart-link').forEach((link) => {
          link.setAttribute('aria-label', `Panier, ${cart.item_count || 0} articles`);
        });
      }

      if (status) {
        status.textContent = 'Produit ajouté au panier. Ouverture du panier…';
        status.classList.add('is-success');
        status.hidden = false;
      }
      if (text) text.textContent = 'Ajouté au panier';
      window.setTimeout(() => window.location.assign(root.dataset.cartUrl || '/cart'), 500);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Ajout impossible pour le moment.';
      if (status) {
        status.textContent = message;
        status.classList.add('is-error');
        status.hidden = false;
      }
      if (text) text.textContent = defaultText;
      if (button) button.disabled = false;
      form.dataset.submitting = 'false';
    }
  });
});

document.querySelectorAll('product-recommendations').forEach(async (element) => {
  if (!element.dataset.url) return;
  try {
    const response = await fetch(element.dataset.url);
    if (!response.ok) return;
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const replacement = html.querySelector('product-recommendations');
    if (replacement?.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
  } catch (_) {
    /* Recommendations are optional; keep the product page usable. */
  }
});
